import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useMainTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';
import { CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const AtlasV2TotalTrafficKeywordCountWithTotalTraffic = () => {
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const entityPhrase = useEntityPhrasing();
  const comparisonTimeDisplayName = useComparisonTimePeriodShortDisplayName();
  const taxonomyText = useTaxonomySubtitleText();

  return (
    <AtlasV2DorisSplineChart
      queryKey="totalTrafficKeywordCountSplineChart"
      title="Keyword Count with Total Traffic"
      metricTypeDisplay={METRICTYPE.VOLUME}
      showLastWeekValue
      metricType="keywordsWithTotalTrafficCount"
      splineChartProps={{ chartContextId: CHART_NAMES.KEYWORD_COUNT_TRAFFIC_SPLINE }}
      beaconChartWithLegendOverride={(props) => {
        return {
          ...props,
          includeSummaryInfo: false,
          loadingComponent: <SplineChartLoading includeSubtitle />,
          subtitle: (
            <BeaconSubtitleContainer>
              <Text variant="body1" lineHeight="24px">
                {`The chart displays the unique number of keywords that generated total traffic for ${entityPhrase} ${taxonomyText} during the 
                ${mainTimePeriodShortDisplayName} period compared to the ${comparisonTimeDisplayName}.`}
                <SubtitleFilters showFilterNumber={false} />
              </Text>
            </BeaconSubtitleContainer>
          )
        };
      }}
    />
  );
};
export default AtlasV2TotalTrafficKeywordCountWithTotalTraffic;
